<script>
  import { M, External } from '../../../external';
  import { ignore } from '../../../Common/tools';
  import { onMount } from 'svelte';
  import WallsService from '../service';
  import ImagePicker from '../../../Common/ImagePicker.svelte';
  import ColorPicker from '../../../Common/ColorPicker.svelte';
  import DropdownInputWithSearchAndAdd from '../../Common/DropdownInputWithSearchAndAdd.svelte';
  export let wall,
    onChange = ignore,
    refreshUI = ignore,
    showGroupStyleSettings;

  const existingWalls = {
    isLoading: false,
    data: []
  };

  const numberOptions = [3, 5, 10, 20];
  const popupLayoutOptions = [
    { name: M.WITH_COMMENTS_BELOW, value: 'row' },
    { name: M.WITH_SIDEBAR_COMMENTS, value: 'column' }
  ];
  const reactionTypeOptions = [
    { name: M.LET_USER_CHOOSE, value: 'unset' },
    { name: M.EMOJI_REACTIONS, value: 'standard' },
    { name: M.UPVOTE_REACTIONS, value: 'upvote' }
  ];
  const roleOptions = [
    { value: 0, name: M.ONLY_ADMINS },
    { value: 1, name: M.ADMINS_MODERATORS },
    { value: 2, name: M.ALL_MEMBERS }
  ];

  const displayTypeChanged = (type) => {
    wall.displayType = type;
    onChange();
    refreshUI();
  };

  let selectedContext = {
    resourceId: '',
    name: '',
    moderation: { writePermission: 0, approvalRequired: 0 },
    commentModeration: { writePermission: 0, approvalRequired: 0 },
    extra: {
      allowMentions: true,
      allowImages: true,
      notifyOnReply: 'ONLY_FIRST_DEPTH'
    }
  };

  const onContextChanged = (selected) => {
    wall.resourceId = selected.resourceId;
    wall.groupSettings.name = selected.name;
    selectedContext = selected;
    onChange();
    refreshUI();
    checkIfContextIsOutdated();
  };

  const onContextUpdated = (partialUpdate) => {
    WallsService.partialUpdateContext('wall', wall.resourceId, partialUpdate);
  };

  const checkIfContextIsOutdated = () => {
    if (!selectedContext.extra.notifyOnReply) {
      if (confirm("Context out-of-date. 'notifyOnReply' is not set. Do you want me to upgrade?")) {
        onContextUpdated({ extra: { notifyOnReply: 'ONLY_FIRST_DEPTH' } });
        selectedContext.extra.notifyOnReply = 'ONLY_FIRST_DEPTH';
      }
    }
  };

  const onChangeAndRefreshUI = () => {
    onChange();
    refreshUI();
  };

  onMount(async () => {
    existingWalls.isLoading = true;
    existingWalls.data = await WallsService.getContexts();
    selectedContext = existingWalls.data.find((context) => context.resourceId === wall.resourceId) || {
      resourceId: '',
      name: '',
      moderation: { writePermission: 0, approvalRequired: 0 },
      commentModeration: { writePermission: 0, approvalRequired: 0 },
      extra: {
        allowMentions: true,
        allowImages: true,
        notifyOnReply: 'ONLY_FIRST_DEPTH'
      }
    };
    existingWalls.isLoading = false;

    checkIfContextIsOutdated();
  });
</script>

<div class="input-wrapper">
  <div class="info" style="width: 100%; margin-top: 5px">
    <h5>{M.ENTER_WALL_NAME}</h5>
  </div>
  {#if !existingWalls.isLoading}
    <div class="col20 f-left">
      <DropdownInputWithSearchAndAdd
        service={WallsService}
        inputValue={selectedContext.name}
        onChange={onContextChanged}
        options={existingWalls.data} />
    </div>
  {/if}
</div>
<ul class="option-select option-select-new t-left option-select-2 mt-5">
  <li class:active={wall.displayType === 'full'}>
    <a class="one-step-form ml-0" on:click={() => displayTypeChanged('full')}
      ><img class="option-image" src="{External.resources}/images/wall-full.png" />{M.FULL_POST}</a>
  </li>
  <li class:active={wall.displayType === 'compact'}>
    <a class="multi-step-form" on:click={() => displayTypeChanged('compact')}
      ><img class="option-image" src="{External.resources}/images/wall-compact.png" />{M.COMPACT_VIEW}</a>
  </li>
</ul>

<div class="info" style="width: 100%; margin-top: 5px">
  <h5>{M.POST_POPUP_ON_CLICK}</h5>
  <span>{M.POST_POPUP_ON_CLICK_DESC}</span>
</div>
<select class="col20 f-left" bind:value={wall.popupLayout} on:change={onChange}>
  {#each popupLayoutOptions as option}
    <option value={option.value}>{option.name}</option>
  {/each}
</select>
{#if wall.popupLayout === 'column'}
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="collapseComments"
        bind:checked={wall.collapseComments}
        on:change={onChange}
        class="css-checkbox"
        type="checkbox"
        name="collapseComments" />
      <label for="collapseComments" class="css-label button-tooltip" data-original-title="" title=""
        >{M.COLLAPSE_COMMENTS}
        <p>{M.COLLAPSE_COMMENTS_DESC}</p></label>
    </div>
  </div>
{/if}
<div class="info" style="width: 100%; margin-top: 5px">
  <h5>{M.CHOOSE_REACTION_TYPE}</h5>
  <span>{M.CHOOSE_REACTION_TYPE_DESC}</span>
</div>
<select class="col20 f-left" bind:value={wall.reactionType} on:change={onChange}>
  {#each reactionTypeOptions as option}
    <option value={option.value}>{option.name}</option>
  {/each}
</select>
{#if wall.displayType === 'compact'}
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="showPostAuthorOnCompact"
        bind:checked={wall.showPostAuthorOnCompact}
        on:change={onChangeAndRefreshUI}
        class="css-checkbox"
        type="checkbox"
        name="showPostAuthorOnCompact" />
      <label for="showPostAuthorOnCompact" class="css-label button-tooltip" data-original-title="" title=""
        >{M.SHOW_POST_AUTHOR}</label>
    </div>
  </div>
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="showUpvoteRatingOnCompact"
        bind:checked={wall.showUpvoteRatingOnCompact}
        on:change={onChangeAndRefreshUI}
        class="css-checkbox"
        type="checkbox"
        name="showUpvoteRatingOnCompact" />
      <label for="showUpvoteRatingOnCompact" class="css-label button-tooltip" data-original-title="" title=""
        >{M.SHOW_UPVOTES}
        <p>{M.SHOW_UPVOTES_DESC}</p></label>
    </div>
  </div>
{/if}

<div class="popup-input-wrapper mb-0 mt-10">
  <div class="info">
    <h5>{M.SOCIAL_WHO_CAN_POST}</h5>
  </div>
  <select
    class="col20 f-left"
    bind:value={selectedContext.moderation.writePermission}
    on:change={() => {
      onContextUpdated({ moderation: { writePermission: selectedContext.moderation.writePermission } });
    }}>
    {#each roleOptions as option}
      <option value={option.value}>{option.name}</option>
    {/each}
  </select>
</div>
<div class="popup-input-wrapper mb-0">
  <div class="checkbox-wrapper">
    <input
      id="isModerationEnabled"
      checked={selectedContext?.moderation?.approvalRequired < 2}
      on:change={(event) => {
        event.target.checked
          ? onContextUpdated({ moderation: { approvalRequired: 1 } })
          : onContextUpdated({ moderation: { approvalRequired: 2 } });
      }}
      class="css-checkbox"
      type="checkbox"
      name="isModerationEnabled" />
    <label for="isModerationEnabled" class="css-label button-tooltip" data-original-title="" title=""
      >{M.REQUIRED_APPROVAL_POSTS}
      <p>{M.REQUIRED_APPROVAL_POSTS_DESC}</p></label>
  </div>
</div>

<h4 class="col20 f-left mt-15 mb-15 t-left"><b>{M.WALL_COMMENT_SECTION}</b></h4>
<div class="info" style="width: 100%; margin-top: 5px">
  <h5>{M.NUMBER_OF_COMMENTS_TO_DISPLAY_FOR_EACH_POST}</h5>
</div>
<select class="col20 f-left" bind:value={wall.commentSection.initialCommentCount} on:change={onChange}>
  {#each numberOptions as option}
    <option value={option}>{option}</option>
  {/each}
</select>
<div class="popup-input-wrapper mb-0 mt-10">
  <div class="info">
    <h5>{M.SOCIAL_WHO_CAN_COMMENT}</h5>
  </div>
  <select
    class="col20 f-left"
    bind:value={selectedContext.commentModeration.writePermission}
    on:change={() => {
      onContextUpdated({ commentModeration: { writePermission: selectedContext.commentModeration.writePermission } });
    }}>
    {#each roleOptions as option}
      <option value={option.value}>{option.name}</option>
    {/each}
  </select>
</div>
<div class="popup-input-wrapper mb-0">
  <div class="checkbox-wrapper">
    <input
      id="commentIsModerationEnabled"
      checked={selectedContext?.commentModeration?.approvalRequired < 2}
      on:change={(event) => {
        event.target.checked
          ? onContextUpdated({ commentModeration: { approvalRequired: 1 } })
          : onContextUpdated({ commentModeration: { approvalRequired: 2 } });
      }}
      class="css-checkbox"
      type="checkbox"
      name="commentIsModerationEnabled" />
    <label for="commentIsModerationEnabled" class="css-label button-tooltip"
      >{M.REQUIRE_APPROVAL_COMMENT}
      <p>{M.REQUIRED_APPROVAL_COMMENT_DESC}</p></label>
  </div>
</div>

{#if showGroupStyleSettings}
  <h4 class="col20 f-left mt-15 mb-15 t-left"><b>{M.HEADER_STYLE}</b></h4>
  <div class="popup-input-wrapper">
    <h5>{M.GROUP_IMAGE}</h5>
    <span class="col20 f-left small-info-text mt-5"
      >{M.GROUP_IMAGE_DESC}</span>
    <ImagePicker
      onChange={onChangeAndRefreshUI}
      bind:image={wall.groupSettings.icon.image}
      bind:imageBase={wall.groupSettings.icon.imageBase} />
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.GROUP_DESC}</h5>
    <input type="text" bind:value={wall.groupSettings.description} on:blur={onChangeAndRefreshUI} />
  </div>
  <div class="popup-input-wrapper mb-0">
    <div class="checkbox-wrapper">
      <input
        id="useColorAsBg"
        bind:checked={wall.groupSettings.useColorAsBg}
        on:change={onChangeAndRefreshUI}
        class="css-checkbox"
        type="checkbox"
        name="useColorAsBg" />
      <label for="useColorAsBg" class="css-label button-tooltip" data-original-title="" title=""
        >{M.SHOW_GROUP_BG}</label>
    </div>
  </div>
  <div class="input-wrapper col20 f-left color-pick-wrap-widgets">
    <ColorPicker
      bind:color={wall.groupSettings.color}
      label={M.GROUP_COLOR}
      onChange={onChangeAndRefreshUI} />
  </div>
{/if}
